export default __webpack_public_path__ + "static/media/chennai.f9961a4c.webp";